import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Client {
  id: number;
  identifiant: string;
  url_site_web: string | null;
  interne: boolean | null;
  siteOuContrat: string | null;
  businessUnit: string | null;
}

export interface Region {
  id: number;
  nom: string;
}

export interface Territoire {
  id: number;
  nom: string;
}


export interface ClientPayload {
  identifiant: string;
  url_site_web?: string;
  interne?: boolean | null;
  siteOuContrat?: string | null;
  businessUnit?: string | null;
}

@Injectable({ providedIn: 'root' })
export class ClientsService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/clients`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<Client[]> {
    return this.http
      .get<{ items?: Client[] } | Client[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  getById(id: number): Observable<Client> {
    return this.http
      .get<Client>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }

  create(payload: ClientPayload): Observable<Client> {
    return this.http
      .post<Client>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: ClientPayload): Observable<Client> {
    return this.http
      .put<Client>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }

}
